var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content d-flex align-items-center justify-content-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }